//讲师邀请确认
import React from 'react';
import '../../assets/css/common/teacher/index.css';
import {localParam} from '../../assets/js/utils/util.js';
import {request} from '../../assets/js/libs/request.js';
import config from '../../assets/js/conf/config.js';
import { Toast } from 'antd-mobile';


export default class teacherIndex extends React.Component {
	constructor(props){
		super(props)
		this.state = {
			UrlDate: props.location.search?localParam(props.location.search).search: localStorage['UrlDate'] !== undefined?JSON.parse(localStorage['UrlDate']):'',
			AM06Data: null,
			AM06mun: 10,
			openId: '',
			AccessToken: ''
		};
		this.bSubmit = true;
	}
	componentDidMount(props) {
		//console.log(this.state.UrlDate.AM05Id)
		//设置分享进来参数
		localStorage['UrlDate'] = JSON.stringify(this.state.UrlDate);
		
		request(config.baseUrl+'api/AM/AM06?inviteId='+this.state.UrlDate.AM05Id, "post").then(res=>{
		    //console.log(res, rAction)0正常 1邀请函无效 2邀请函已被使用 3邀请函已过期
		    if(res.code == 0){
		    	this.setState({
					AM06Data: res.data == 0?"正常":res.data == 1?"邀请函无效":res.data == 2?"进入直播间":'邀请函已过期',
					AM06mun: res.data
				})
		    }
		});
		
		var state = this.GetQueryString("state");
		if(state == 101){
			//刷新页面获取code
			var code = this.GetQueryString("code");
			let data = {
				code: code
			}
			//获取openId和AccessToken
			let that = this;
			request(config.baseUrl+'api/Study/S005', 'post', data).then(res=>{
			    if (res && res.code === 0){
			        this.setState({
			        	openId: res.data.openId,
			    		AccessToken: res.data.accessToken
			        })
					this.submitAM02();
				}
			})
		}
	}
	componentWillUnmount(){
    	//界面离开的时候
		this.setState = (state, callback)=>{
			return;
		}
	}
	getCode(){
		var code = this.GetQueryString("code");
		//alert(code)
		if (code == "" || code == null || code == undefined) {
			let url = this.urlencode(window.location.href);
			//let url = this.urlencode('http://ptt.zlgxt.cn/h5/index.html?#/teacher');
			let WXurl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx2ac90c6545e0135e&redirect_uri="+ url +"&response_type=code&scope=snsapi_base&state=101#wechat_redirect";
			window.location.href = WXurl;
			return
		}
	}
	btnClick(){
		if(this.state.AM06mun == 0 || this.state.AM06mun == 2 ){
			this.getCode();
		}
	}
	urlencode(str) {
		//转码
		str = (str + '').toString();
		return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').
		replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');
	}
	GetQueryString(name) {
		//获取链接所带参数
		var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
		var r = window.location.search.substr(1).match(reg);
		if (r != null) return r[2];
		return null;
	}
	//注册讲师
	submitAM02(){
		let data = {
			"inviteId": this.state.UrlDate.AM05Id,
			"openId": this.state.openId,
			"accessToken": this.state.AccessToken
		}
		request(config.baseUrl+'api/AM/AM02', "post", data).then(res=>{
			if (res.code === 0){
				localStorage['LoginData'] = JSON.stringify(res.data);
				
				//http://ptt.zlgxt.cn/h5/index.html?code=033Ncg0w3n4PnV2Vyl3w323lfz0Ncg0p&state=STATE#/video/detail?olId=16
				
				if(this.state.AM06mun == 0){
					this.props.history.replace('/teacherIn');
				}else if(this.state.AM06mun == 2){
					this.props.history.replace('/video/detail?olId='+this.state.UrlDate.merchandiseId);
				}
			}
		});
	}
	
	render() {
		return(
			<div className={'teacher'}>
				<div className={'teacherContent'}>
					<div className='top'>
						<div>
							<img src={this.state.UrlDate.photo?this.state.UrlDate.photo:require('../../assets/images/common/my1.png')} />
						</div>
						<h5>{this.state.UrlDate.name?decodeURIComponent(this.state.UrlDate.name):''}</h5>
						<p>邀请您成为<br />{this.state.UrlDate.merchandise?'【'+decodeURIComponent(this.state.UrlDate.merchandise)+'】讲师':''}</p>
					</div>
					<div className='XF'>
						<img src={require('../../assets/images/teacher/jsImg8.png')} />
						<button className={this.state.AM06mun == 0?'':'hide'} onClick={this.btnClick.bind(this)}>接受邀请</button>
						<div className={this.state.AM06mun == 0?'hide':''} onClick={this.btnClick.bind(this)}>{this.state.AM06Data}</div>
					</div>
				</div>
		    </div>
		);
	}
}